// Import mutations
import { GET_PHASES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_PHASES] (state, phases) {
    state.all = phases
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/phases.js